import { onFontsReady } from "../utils/onFontsReady";
import { initFontsGate } from "../utils/initFontsGate";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

initFontsGate("Manrope", [400, 700]);

function initHero(wrapper) {
  if (!wrapper || wrapper.dataset.gsapHeroInited) return;
  wrapper.dataset.gsapHeroInited = "1";

  const content = wrapper.querySelector(".wv-hero-content");
  if (!content) return;

  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

  const imgWrap = wrapper.querySelector(".section-img-wrapper");
  const img = wrapper.querySelector(".section-img");
  const placeholder = wrapper.querySelector(".section-placeholder-img");

  const items = Array.from(content.children);

  gsap.set(items, { opacity: 0, y: 14 });
  if (imgWrap) gsap.set(imgWrap, { opacity: 0 });
  if (img) gsap.set(img, { opacity: 0, y: 14 });
  if (placeholder) gsap.set(placeholder, { opacity: 0, y: 6 });

  let imageAnimated = false;

  const tl = gsap.timeline({
    paused: true,
    defaults: { ease: "power2.out" },
  });

  tl.to(items, {
    opacity: 1,
    y: 0,
    duration: 0.75,
    stagger: 0.2,
    clearProps: "transform,opacity",
  });

  if (imgWrap && img) {
    const addImageToTimeline = () => {
      if (imageAnimated) return;
      imageAnimated = true;

      tl.to(imgWrap, { opacity: 1, duration: 0.35, clearProps: "opacity" }, "-=0.45")
        .to(
          img,
          {
            opacity: 1,
            y: 0,
            duration: 0.75,
            ease: "power2.out",
            clearProps: "transform,opacity",
          },
          "<"
        );
    };

    if (img.complete && img.naturalWidth > 0) addImageToTimeline();
    else {
      img.addEventListener("load", addImageToTimeline, { once: true });
      img.addEventListener("error", addImageToTimeline, { once: true });
    }
  }

  if (placeholder) {
    tl.to(
      placeholder,
      {
        opacity: 1,
        y: 0,
        duration: 0.9,
        ease: "power1.out",
        clearProps: "transform,opacity",
      },
      "-=0.7"
    );
  }

  ScrollTrigger.create({
    trigger: wrapper,
    start: "top 80%",
    once: true,
    onEnter: () => tl.play(),
  });
}

onFontsReady(() => {
  document.querySelectorAll(".wv-hero-wrapped").forEach(initHero);
});
